import { render, staticRenderFns } from "./ReferralCodeEdit.vue?vue&type=template&id=0c8dda46&scoped=true&"
import script from "./ReferralCodeEdit.vue?vue&type=script&lang=ts&"
export * from "./ReferralCodeEdit.vue?vue&type=script&lang=ts&"
import style0 from "./ReferralCodeEdit.vue?vue&type=style&index=0&id=0c8dda46&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8dda46",
  null
  
)

export default component.exports